import { Divider, Typography } from '@mui/material'
import { useOrderStore } from 'modules/orders/store'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { stringToNumber } from 'utils'
import {
  ItemConfigurationReplicateDrawer,
  useItemConfigurationReplicateDrawerStore
} from './ItemConfiguration'
import { ItemDrawer } from './ItemForm'

import { useItemFormDrawerStore } from './ItemForm/itemFormDrawerStore'
import { ItemsList } from './ItemsList'
import { ListDrawer } from './ListDrawer'
import { MaterialsListDrawer } from './ListDrawer/MaterialsListDrawer'
import { RecalculeAlert } from '../../recalculeAlert'

export default function Items() {
  const setIsDrawerOpen = useItemFormDrawerStore.useSetIsDrawerOpen()
  const setProductId = useItemFormDrawerStore.useSetProductId()
  const isItemDrawerOpen = useItemFormDrawerStore.useIsDrawerOpen()
  const isItemConfigurationReplicateDrawerOpen =
    useItemConfigurationReplicateDrawerStore.useIsDrawerOpen()

  const { watch } = useFormContext()

  const form = useOrderStore.useForm()
  const { setError, clearErrors, setValue } = useFormContext()
  const orderType = watch('orderType')

  const totalQuantity =
    form?.orderItems?.reduce(
      (acc: any, cur: any) => +acc + Number(stringToNumber(cur.quantityUn)),
      0
    ) || 0

  // Verifica se algum item do pedido é um material
  const hasMaterialItem = form?.orderItems?.some(
    (item: any) => item.isMaterial === true
  )

  useEffect(() => {
    if (!form?.orderItems.length) {
      setError('orderItems', { message: 'é necessário pelo menos 1 item' })
    } else {
      clearErrors('orderItems')
    }
    setValue('orderItems', form?.orderItems)
  }, [clearErrors, form?.orderItems, setError, setValue])

  return (
    <div style={{ width: '100%' }}>
      <RecalculeAlert />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 12,
          position: 'relative'
        }}
      >
        <Typography variant="h6">
          {'Itens no Pedido ' +
            `(${form?.orderItems?.length}) | Peças (${totalQuantity} UN)`}
        </Typography>
        <div style={{ display: 'flex', gap: 8 }}>
          {orderType?.id !== 'P' && (
            <ListDrawer
              onSelect={(item: any) => {
                setIsDrawerOpen(true)
                setProductId(item.id)
              }}
            />
          )}
          {(orderType?.id === 'P' || orderType?.id === 'T') && (
            <MaterialsListDrawer
              onSelect={(item: any) => {
                setIsDrawerOpen(true)
                // Garante que o productId seja o ID do produto/material
                const materialId = item?.product?.id || item?.id
                setProductId(materialId)
              }}
            />
          )}
        </div>
      </div>
      <Divider />

      {isItemDrawerOpen && (
        <ItemDrawer
          unityId={watch('unity')?.id}
          customerId={watch('customer')?.id}
          invoiceTypeId={watch('orderType')?.id}
        />
      )}

      {isItemConfigurationReplicateDrawerOpen && (
        <ItemConfigurationReplicateDrawer />
      )}

      <div>
        <ItemsList />
      </div>
    </div>
  )
}
